import { CommonStylesDefaultValues } from 'cms/cms-shared/common-settings-styles/common-settings-styles.models';
import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';


export const initialSlotState = {
  flexGrow: 0,
  flexShrink: 1,
  flexBasis: 'auto',
  minWidth: null,
  width: '100%',
  maxWidth: null,
  minHeight: null,
  height: 'auto',
  maxHeight: null,
};

export const SliceStickyDefinition: IdtComponentDefinition = {
  id: 'slice-sticky',
  role: IdtComponentRole.Slice,
  numSlots: 0,
};

export const SliceStickyCmsDefinition: IdtComponentCmsDefinition = {
  name: 'sticky',
  group: CmsComponentGroups.Basic,
  availablePlatforms: ['web'],
  initialSettings: () => {
    return {
      general: {
        justifyContent: 'center',
        alignItems: 'flex-start',
        alignContent: 'stretch',
        flexDirection: 'row',
        position: 'up',
        showCloseButton: true,
        keepClosedSession: false
      },
      slots: [
        {
          ...initialSlotState
        }
      ],
      styles: {
        ...CommonStylesDefaultValues,
        paddingTop: '0pt',
        paddingBottom: '0pt',
        paddingLeft: '0pt',
        paddingRight: '0pt',
        textPositionVertical: 'up',
      },
      animations: {}
    };
  }
};
